import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#41479B"
  }} d="M0,385.376c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345  v-73.465H0V385.376z" /><path style={{
    fill: "#73AF00"
  }} d="M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v73.478h512v-73.478  C512,105.517,494.955,88.403,473.885,88.279z" /><rect y={200.1} style={{
    fill: "#F5F5F5"
  }} width={512} height={111.81} /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };